import { render } from "./NewDonorVitalsForm.vue?vue&type=template&id=031f9302&scoped=true"
import script from "./NewDonorVitalsForm.vue?vue&type=script&lang=js"
export * from "./NewDonorVitalsForm.vue?vue&type=script&lang=js"

import "./NewDonorVitalsForm.vue?vue&type=style&index=0&id=031f9302&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-031f9302"]])

export default __exports__